import { FC, ReactElement, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { ResetPasswordForm } from '../../../containers';
import { NewPasswordFormBase } from '../../../entities/@forms/ChangePasswordForm/ChangePasswordForm';
import { AppRoute, appRoutes } from '../../../entities/Routing/Routing';
import { useTrans } from '../../../hooks';
import { resetPassword } from '../../../redux/@account/resetPassword/resetPasswordActions';
import { useTypedDispatch, useTypedSelector } from '../../../redux/store';

interface ConnectedResetPasswordFormProps {
    token: string;
    emailAddress: string;
    className?: string;
}

export const ConnectedResetPasswordForm: FC<ConnectedResetPasswordFormProps> = ({
    token,
    emailAddress,
    className = '',
}): ReactElement => {
    const trans = useTrans();
    const dispatch = useTypedDispatch();
    const navigate = useNavigate();

    const { isLoading, hasChangedSuccessfully, error } = useTypedSelector(state => state.resetPasswordSlice);

    useEffect((): void => {
        if (hasChangedSuccessfully) {
            navigate(`${trans(appRoutes[AppRoute.login].path)}?emailAddress=${emailAddress}`, { replace: true });
        }
    }, [hasChangedSuccessfully]);

    const handleSubmit = (formData: NewPasswordFormBase): void => {
        dispatch(resetPassword({ token, formData }));
    };

    return (
        <ResetPasswordForm
            isLoading={isLoading}
            isSuccessful={hasChangedSuccessfully}
            error={error}
            onSubmit={handleSubmit}
            className={className}
        />
    );
};
